import Icon from './Icon';
import { ICONS } from '../lib/icons';

// An in-page create/edit form. Create and edit never open a popup — the form
// expands in place above the list it belongs to, so the surrounding data stays
// visible while you type. Modals are reserved for confirmations.
export default function InlineForm({
  title,
  onSubmit,
  onCancel,
  submitting = false,
  submitLabel = 'Save',
  error,
  children,
}) {
  return (
    <section className="inline-form">
      <header className="inline-form__head">
        <h3 className="inline-form__title">{title}</h3>
        <button
          type="button"
          className="icon-btn"
          onClick={onCancel}
          aria-label="Close form"
        >
          <Icon name={ICONS.close} />
        </button>
      </header>

      <form className="form" onSubmit={onSubmit}>
        {children}

        {error ? <div className="form-error">{error}</div> : null}

        <div className="inline-form__foot">
          <button type="button" className="btn btn--ghost" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="btn btn--primary" disabled={submitting}>
            {submitting ? 'Saving…' : submitLabel}
          </button>
        </div>
      </form>
    </section>
  );
}
